export default "__VITE_ASSET__CT50pu2z__"